export type BrandKitState = 'draft' | 'submitted' | 'building' | 'live';

export type BrandKitAspectRatio = '9:16' | '1:1' | '16:9';

export type BrandKitCaptionFontFamily = 'display' | 'sans' | 'condensed' | 'mono';
/** No `top`: the renderer can't draw it, and server_pray refuses it with 400. */
export type BrandKitCaptionPosition = 'bottom' | 'lower-third' | 'middle';

export const BRAND_KIT_CAPTION_POSITIONS: readonly BrandKitCaptionPosition[] = ['bottom', 'lower-third', 'middle'];
export type BrandKitCaptionSize = 'small' | 'medium' | 'large';
export type BrandKitCaptionAnimation = 'pop' | 'rise' | 'highlight';

/**
 * How captions look on reels made from a sermon; the caption colour, highlight colour, caption font and logo are the
 * kit's own fields. Optional and nullable: a kit saved without them keeps the renderer's defaults.
 */
export type BrandKitCaptionStyleFields = {
  /** null: the family closest to `caption_font_name` */
  caption_font_family?: BrandKitCaptionFontFamily | null;
  caption_size?: BrandKitCaptionSize | null;
  caption_position?: BrandKitCaptionPosition | null;
  caption_animation?: BrandKitCaptionAnimation | null;
  caption_uppercase?: boolean | null;
  /** null: on when the kit has a logo */
  logo_on_reels?: boolean | null;
};

export const BRAND_KIT_CAPTION_STYLE_KEYS: readonly (keyof BrandKitCaptionStyleFields)[] = [
  'caption_font_family',
  'caption_size',
  'caption_position',
  'caption_animation',
  'caption_uppercase',
  'logo_on_reels',
];

export type BrandKitFields = BrandKitCaptionStyleFields & {
  logo_url: string | null;
  primary_color: string | null;
  secondary_color: string | null;
  caption_color: string | null;
  highlight_color: string | null;
  headline_font_name: string | null;
  headline_font_url: string | null;
  caption_font_name: string | null;
  caption_font_url: string | null;
  intro_url: string | null;
  outro_url: string | null;
  aspect_ratios: BrandKitAspectRatio[];
  notes: string | null;
};

export type BrandKit = BrandKitFields & {
  id: string | null;
  status: 'draft' | 'submitted' | 'building';
  state: BrandKitState;
  ticket_reference: string | null;
  submitted_at: string | null;
  opus_brand_template_id: string | null;
};

export type BrandKitPrefill = {
  logo_url: string | null;
  website_url: string | null;
  style_guide: string | null;
};

export type BrandKitResponse = {
  eligible: boolean;
  brand_kit: BrandKit;
  prefill: BrandKitPrefill | null;
};

export type AdminBrandKitQueueItem = {
  artist_id: string;
  artist_name: string;
  artist_handle: string | null;
  status: 'submitted' | 'building';
  submitted_at: string | null;
  ticket_reference: string | null;
};
